export * from './beneficiary-documents.component'